export default __webpack_public_path__ + "static/media/phone-lumin.691e4497.jpg";